<div class="brand-logos">
  <a
    class="brand-logos__card-link-wrapper"
    *ngFor="let brand of brands | slice: NUMBER_0:accordionLimit"
    (click)="onBrandClick(brand.value)"
    [routerLink]="[getBrandPath(brand.value), brand.value]"
  >
    <article class="brand-logos__card-link-wrapper__logo">
      <img [src]="brand.logo" [alt]="brand.name">
    </article>
  </a>
</div>

<div class="expander" *ngIf="isMobile && brands.length > NOT_EXPANDED_LIMIT">
  <button type="button" class="toggle" (click)="toggleExpanded()">
    {{ (isExpanded ? 'SHARED.SHOW_LESS.LABEL' : 'SHARED.SHOW_MORE.LABEL') | translate }}
  </button>

  <mat-icon *ngIf="!isExpanded">expand_more</mat-icon>
  <mat-icon *ngIf="isExpanded">expand_less</mat-icon>
</div>
